/**
 * Comprehensive list of major cities in Germany.
 * Used for city selection (e.g. "Your City Is Not Listed?" modal).
 */

export const GERMAN_CITIES = [
    'Aachen',
    'Augsburg',
    'Berlin',
    'Bielefeld',
    'Bochum',
    'Bonn',
    'Bottrop',
    'Braunschweig',
    'Bremen',
    'Bremerhaven',
    'Chemnitz',
    'Cologne',
    'Cottbus',
    'Darmstadt',
    'Dortmund',
    'Dresden',
    'Duisburg',
    'Düsseldorf',
    'Erfurt',
    'Erlangen',
    'Essen',
    'Frankfurt am Main',
    'Frankfurt (Oder)',
    'Freiburg im Breisgau',
    'Fürth',
    'Gelsenkirchen',
    'Göttingen',
    'Hagen',
    'Halle (Saale)',
    'Hamburg',
    'Hamm',
    'Hanover',
    'Heidelberg',
    'Heilbronn',
    'Herne',
    'Hildesheim',
    'Ingolstadt',
    'Jena',
    'Karlsruhe',
    'Kassel',
    'Kiel',
    'Koblenz',
    'Krefeld',
    'Leipzig',
    'Leverkusen',
    'Lübeck',
    'Ludwigshafen am Rhein',
    'Magdeburg',
    'Mainz',
    'Mannheim',
    'Moers',
    'Mönchengladbach',
    'Mülheim an der Ruhr',
    'Munich',
    'Münster',
    'Neuss',
    'Nuremberg',
    'Oberhausen',
    'Offenbach am Main',
    'Oldenburg',
    'Osnabrück',
    'Paderborn',
    'Pforzheim',
    'Potsdam',
    'Recklinghausen',
    'Regensburg',
    'Remscheid',
    'Reutlingen',
    'Rostock',
    'Saarbrücken',
    'Salzgitter',
    'Siegen',
    'Solingen',
    'Stuttgart',
    'Trier',
    'Ulm',
    'Wiesbaden',
    'Wolfsburg',
    'Wuppertal',
    'Würzburg',
].sort()


